/**
 * Pure H OS · Sprint 4 · Commerce OS shell (sub-nav).
 */
import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard, ShoppingBag, Package, Boxes, Tag, Percent, RefreshCcw, Signal, ShoppingCart,
} from "lucide-react";

const SUBNAV = [
  { to: "overview",   label: "Overview",    icon: LayoutDashboard },
  { to: "orders",     label: "Orders",      icon: ShoppingBag     },
  { to: "products",   label: "Products",    icon: Package         },
  { to: "inventory",  label: "Inventory",   icon: Boxes           },
  { to: "pricing",    label: "Pricing",     icon: Tag             },
  { to: "promotions", label: "Promotions",  icon: Percent         },
  { to: "sync",       label: "Shopify Sync",icon: RefreshCcw      },
  { to: "signals",    label: "Signals",     icon: Signal          },
];

export default function CommerceLayout() {
  return (
    <div data-testid="pureh-commerce">
      <div className="mb-4">
        <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mb-2 inline-flex items-center gap-1.5">
          <ShoppingCart size={11} /> Commerce OS
        </div>
        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">ORVAN Perfumes · Commerce</h1>
      </div>

      <nav data-testid="commerce-subnav" className="mb-6 -mx-1 overflow-x-auto">
        <div
          className="inline-flex items-center gap-1 p-1"
          style={{
            background: "var(--ph-surface)",
            border: "1px solid var(--ph-border-subtle)",
            borderRadius: "var(--ph-radius-md)",
          }}
        >
          {SUBNAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`cm-subnav-${item.to}`}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium transition-colors"
              style={({ isActive }: { isActive: boolean }) => ({
                background: isActive ? "var(--ph-surface-card)" : "transparent",
                color: isActive ? "var(--ph-ink-strong)" : "var(--ph-ink-muted)",
                borderRadius: "var(--ph-radius-sm)",
                boxShadow: isActive ? "var(--ph-shadow-card)" : "none",
                border: isActive ? "1px solid var(--ph-border-subtle)" : "1px solid transparent",
              })}
            >
              <item.icon size={13} />
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>

      <Outlet />
    </div>
  );
}
